// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"RuleTypeDropdown_dropdownContainer__86AsP"};